var ChargingVehicleController = /** @class */ (function () {
    function ChargingVehicleController() {
        this.estimatedCurrentCharge = Math.round((this.vehicle.EstimatedCurrentCharge / 100) * this.vehicle.VehicleAutonomyOnFullCharge);
        
        this.isMonta = this.vehicle.ChargingMode == 'Monta';

        if (this.isMonta) {            
            this.isMontaCharging = ['paused', 'stopped'].indexOf(this.vehicle.ExternalState) < 0;

            this.montaStateKey = 'InProgress';

            // NF-1383: (2026.2.6) for Monta state we use 3 state for translate, for other state we consider as "in progress"
            if (['paused', 'stopped', 'starting'].indexOf(this.vehicle.ExternalState) >= 0) {
                this.montaStateKey = 'lbChargingSessionExternalState_' + this.vehicle.ExternalState;
            }

            // this.isMontaCharging = 1==2;
        }
    }
    Object.defineProperty(ChargingVehicleController.prototype, "ChargeStatus", {
        get: function () {
            return ChargeStatus;
        },
        enumerable: false,
        configurable: true
    });
    return ChargingVehicleController;
}());
var ChargingVehicleComponent = /** @class */ (function () {
    function ChargingVehicleComponent() {
        this.bindings = {
            vehicle: '='
        };
        this.controller = ChargingVehicleController;
        this.controllerAs = 'vm';
        this.templateUrl = 'js/internal/charging-vehicle/charging-vehicle.html';
    }
    return ChargingVehicleComponent;
}());
angular.module('internal.chargingvehicle',[]).component('chargingVehicle', new ChargingVehicleComponent());
